// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tEkN","top":"styles_top__34Uez"};